"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _objects = require("libs/utils/objects");
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var LazyAppModule = require('./blueprint/LazyAppModule');
var resolvers = require('./blueprint/resolvers');
// predefined blueprints

// from the definition of modules, build routes
// routeValidator should take a route as a function and return the validated route, or a falsy value if not valid
var buildRoutesFromBlueprint = function buildRoutesFromBlueprint($routeProvider) {
  var blueprint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var routeValidator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (route) {
    return route;
  };
  var vueTemplate = '/static/partials/vue-wrapper.html';
  _.each(blueprint.modules, function (module, moduleKey) {
    if (!module) {
      return;
    }

    // normalize module
    _.defaults(module, {
      sourceUrl: [],
      fullscreen: {}
    });
    module.sourceUrl = _.uniq(_.flatten([module.sourceUrl]));

    // patch up missing props in controllers
    var routePathPrefix = "/event/:eventId/modules/".concat(moduleKey);
    var controllers = module.controllers || {};

    // we need to create all routes at the end when all normalization has happened,
    // as angular does not keep a reference of the module but serialize the route
    // parameters.
    var allRoutes = [];
    _.each(controllers, function (controller, controllerKey) {
      // a custom route or path can be passed in as the controller's `route` or `path` property
      var finalPathEntry = controller.title ? controller.title : "".concat(controllerKey).concat(moduleKey);

      // set default values
      _.defaults(controller, {
        route: "".concat(routePathPrefix, "/").concat(controllerKey),
        path: ['event-instance-content', 'module', "module-".concat(moduleKey), "controller-".concat(controllerKey), "".concat(moduleKey, "#").concat(controllerKey), finalPathEntry],
        controller: _.noop,
        templateUrl: '/static/partials/undefined-module-template.html',
        fullscreen: {}
      });
      var isVue = Boolean(controller.componentName);

      // route could be an array so let's make it one regardless
      _.flatten([controller.route]).forEach(function (route) {
        // validate route
        route = routeValidator(route);
        if (!route) {
          return;
        }
        // if route is valid, continue
        allRoutes.push([route, _.extend({
          reloadOnSearch: false,
          template: controller.template,
          templateUrl: isVue ? vueTemplate : controller.templateUrl,
          controller: isVue ? 'VueWrapperCtrl' : controller.controller,
          resolve: controller.resolve || resolvers(controller.resolvers),
          path: controller.path,
          blueprintMetadata: {
            module: module,
            moduleKey: moduleKey,
            controller: controller,
            controllerKey: controllerKey
          }
        }, controller.routeOptions)]);
      });
    });

    // sort routes by specificity
    allRoutes.sort(function (_ref, _ref2) {
      var _ref3 = _slicedToArray(_ref, 1),
        route1 = _ref3[0];
      var _ref4 = _slicedToArray(_ref2, 1),
        route2 = _ref4[0];
      var route1Blocks = _.compact(route1.split('/'));
      var route2Blocks = _.compact(route2.split('/'));

      // compare routes, looking for params
      var compare = route1Blocks.reduce(function (prev, block, index) {
        if (prev !== 0) {
          return prev;
        }
        var matchingBlock = route2Blocks[index];
        if (!matchingBlock) {
          // route2 is shorter, consider more specific
          return 1;
        }
        if (block[0] === ':') {
          if (matchingBlock[0] !== ':') {
            // route2 does not have a parameter here, more specific
            return 1;
          }
          // both are params, consider it's equal
          return 0;
        }
        if (matchingBlock[0] === ':') {
          // route2 have a parameter, less specific
          return -1;
        }
        // use natural order
        return block.localeCompare(matchingBlock);
      }, 0);

      // if route2 is longer, it's less specific
      if (compare === 0 && route2Blocks.length > route1Blocks.length) {
        return -1;
      }
      return compare;
    });

    // only apply routes now
    _.each(allRoutes, function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
        route = _ref6[0],
        param = _ref6[1];
      return $routeProvider.when(route, param);
    });
  });
};
var BluePrintServiceProvider = /*#__PURE__*/function () {
  BluePrintServiceProvider.$inject = ["$routeProvider", "$controllerProvider", "$compileProvider", "$filterProvider", "$provide", "$injector"];
  // http://blog.brunoscopelliti.com/how-to-defer-route-definition-in-an-angularjs-web-app

  /* @ngInject */
  function BluePrintServiceProvider($routeProvider, $controllerProvider, $compileProvider, $filterProvider, $provide, $injector) {
    var _this = this;
    _classCallCheck(this, BluePrintServiceProvider);
    this.blueprints = null;
    this.currentBlueprint = null;
    this.$routeProvider = $routeProvider;

    // the lazyModuleInstance keeps references to our providers so that we can add components post-bootstrap
    this.lazyModuleInstance = new LazyAppModule($controllerProvider, $compileProvider, $filterProvider, $provide, $injector);

    // attach backstage app module in the global scope
    window.getBackstageAppModule = window.BSTG.getAppModule = function () {
      return _this.lazyModuleInstance;
    };
  }

  /* @ngInject */
  return _createClass(BluePrintServiceProvider, [{
    key: "$get",
    value: ["$http", "$filter", function $get($http, $filter) {
      var provider = this;
      // the default current blueprint.
      // Will be extend with global blueprint, and then event blueprint if needed.
      var currentBlueprint = {};
      var uppercaseFirstCharOfAllWords = $filter('uppercaseFirstCharOfAllWords');
      var uppercaseFirstChar = $filter('uppercaseFirstChar');

      // apply permission to blueprint, build routes. Will return a copy.
      var addBlueprint = function addBlueprint() {
        var blueprint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var routeValidator = arguments.length > 1 ? arguments[1] : undefined;
        buildRoutesFromBlueprint(provider.$routeProvider, blueprint, routeValidator);
        (0, _objects.deepExtend)(currentBlueprint, blueprint);
        return blueprint;
      };
      var service = {
        lazyAppModule: this.lazyModuleInstance,
        /**
         * Get the blueprint modules for the current event,
         * where restricted modules and controllers have been removed
         * @param {String} type if specified, returns modules of the given type
         * @returns {Object}
         */
        getModules: window.BSTG.services.blueprint.getModules.bind(window.BSTG.services.blueprint),
        /**
         * Get an ordered list of nav headings based on the list of defined modules
         * @param {String} type if specified, returns heading of the given type
         * @return {Array}
         */
        getNavHeadings: function getNavHeadings(type) {
          var modules = this.getModules(type);
          if (!modules) {
            return [];
          }
          return _.chain(modules).keys().map(function (moduleKey) {
            var moduleDescriptor = modules[moduleKey] || {};

            // find the first controller, this will be the route we link to
            //  and we'll have to take controller `order` into account to make sure
            //  we link to the correct "first" item
            var firstCtrlPair = _.chain(moduleDescriptor.controllers).pairs().sortBy(function (pair) {
              return pair[1] ? pair[1].order : undefined;
            }).first().value();
            if (!firstCtrlPair || !firstCtrlPair.length) {
              return;
            }
            var _firstCtrlPair = _slicedToArray(firstCtrlPair, 2),
              firstCtrlKey = _firstCtrlPair[0],
              firstCtrlDescriptor = _firstCtrlPair[1];

            // we selectively pick out the attributes of the module descriptor we wish to consider here
            // being selective at this point helps to keep the nav renderer encapsulated with a clean API
            var baseDescriptor = _.pick(moduleDescriptor, 'icon', 'order', 'hideNavUnlessActive');
            var title = moduleDescriptor.title || uppercaseFirstCharOfAllWords(moduleKey);

            // this could be an array (in the case where several routes are specified in a controller)
            var route = _.flatten([(firstCtrlDescriptor || {}).route])[0];
            return _.extend({}, firstCtrlDescriptor, baseDescriptor, {
              ctrlKey: firstCtrlKey,
              moduleKey: moduleKey,
              title: title,
              route: route
            });
          }).compact().sortBy('order').value();
        },
        /**
         * Get controllers headings for a module
         * @param {String} moduleKey
         * @return {Array}
         */
        getControllerHeadings: function getControllerHeadings(moduleKey) {
          var module = currentBlueprint.modules[moduleKey];
          if (!module) {
            return [];
          }
          var controllers = module.controllers || {};
          var list = _.keys(controllers).map(function (ctrlKey) {
            var ctrlDescriptor = controllers[ctrlKey];
            var substituteCtrlTitle = "".concat(ctrlKey, " ").concat((module.title || moduleKey || '').toLowerCase());
            var title = (ctrlDescriptor.title || substituteCtrlTitle).toLowerCase();
            return _.extend({}, ctrlDescriptor, {
              ctrlKey: ctrlKey,
              moduleKey: moduleKey,
              // exception for `Q&A` which would otherwise end up as `Q&a`
              title: title === 'q&a' ? title.toUpperCase() : uppercaseFirstChar(title),
              route: _.flatten([ctrlDescriptor.route])[0]
            });
          });
          return _.sortBy(list, 'order');
        },
        /**
         * Initialize the blueprint service (after a load or a change of users)
         * @return {Promise}
         */
        init: function init(global, eventId) {
          // init service with the global blueprint
          addBlueprint(global);
          // add the 404 route
          provider.$routeProvider.otherwise({
            redirectTo: eventId ? "/event/".concat(eventId) : '/'
          });
        },
        /**
         * Returns current blueprint
         *
         * @returns {Object} current blueprint
         */
        getBlueprint: function getBlueprint() {
          return currentBlueprint;
        }
      };
      return service;
    }]
  }]);
}(); // # # # #
angular.module('backstage.services').provider('blueprintService', BluePrintServiceProvider);